import React, {useState, useEffect, createContext, useRef} from 'react';
import {inject, observer} from "mobx-react";

import { LLPreloader, getLLWidgetList } from '../../components';
import {trans} from '../../common/utils';
import SlotsCasinosGamesMenu from './components/games-menu/games-menu';
import SlotsCasinosGamesList from './components/games-list';
import config from '../../static/themes/config';
import {HomeCarousel} from '../home/components';
import { SlotsBattles } from '../index';


const initFiltering = {
    select: {
        slots: [
            'ActiveThumbnail',
            'BrandName',
            'BrandOrder',
            'Created',
            'GameHeight',
            'GameID',
            'GameName',
            'GameThumbnail',
            'GameUrl',
            'GameWidth',
            'ID',
            'IsPopular',
            'IsPromoted',
            'IsGameNew',
            'FavoriteOrder',
            'Param1',
            'Provider',
            'ProviderID',
            'SortOrder',
            'GameTypeName',
            'GameTypeKey',
            'GameTypeOrder',
            'hasFunMode',
            'LastLaunchTime',
            'thumbnail',
            'jackpotId',
            'JackpotOrder',
        ],
        casino: [
            'ActiveThumbnail',
            'BrandName',
            'BrandOrder',
            'Created',
            'GameHeight',
            'GameID',
            'GameName',
            'GameThumbnail',
            'GameType',
            'GameUrl',
            'GameWidth',
            'ID',
            'IsPopular',
            'IsPromoted',
            'IsGameNew',
            'LimitMax',
            'LimitMin',
            'FavoriteOrder',
            'Param1',
            'Provider',
            'ProviderID',
            'SortOrder',
            'GameTypeName',
            'GameTypeKey',
            'GameTypeOrder',
            'LastLaunchTime',
            'thumbnail',
        ],
    },
    filter: ['IsFeatured', '=', '1'],
    sort: [
        { selector: 'SortOrder', desc: false },
        { selector: 'GameName', desc: false },
    ],
};

export const GamesContext = createContext();

const SlotsCasinos = ({store, gamesType}) => {
    const [filtersLoading, setFiltersLoading] = useState(true);
    const [pageError, setPageError] = useState(false);
    const [activeGameMenuItem, setActiveGameMenuItem] = useState('');
    const [isSubMenuVisible, setSubMenuVisible] = useState(false);
    const [activeSubSubMenuItem, setActiveSubSubMenuItem] = useState();
    const [filtering, setFiltering] = useState({...initFiltering, select: initFiltering.select[gamesType]});
    const [mode, setMode] = useState(0);
    const bannersSliderRef = useRef(null);

    const
        user = store.user,
        viewSize = store.site.status.viewSize,
        slotsCasinoGames = store.slotsCasinoGames,
        widgetsLoading = store.user.widgets.llWidget.isFetching,
        presetFilters = store.slotsCasinoGames.presetFilters,
        getWidgetsByZones = store.user.widgets.llWidget.getWidgetsByZones,
        router = store.router,
        isSlotBattles = store.slotsBattles.isSlotBattlePage;

    const widgetData = getWidgetsByZones(gamesType, viewSize);
    const banners = getLLWidgetList(widgetData, gamesType);

    const gamesMenu = (
        viewSize === 'mobile'
            ? config.slotsCasinoMobileMenu
            : config.slotsCasinoMenu
    ).filter(
        (item) =>
            gamesType !== 'casino' ||
            (item.name !== 'SLOT_BATTLE' && item.type !== 'slots-battles')
    );

    /********* STATE SETTERS *************/
    const setSorting = (sort = null) => {
        setFiltering({
            ...filtering,
            sort: sort ?? [
                { selector: 'SortOrder', desc: false },
                { selector: 'GameName', desc: false },
            ],
        });
    };

    const resetFiltering = () => router.push(`/${gamesType}`);

    const searchGames = (val) => {
        if (val.length > 1) {
            router.push(`/${gamesType}/search=${val}`);
        }
    };

    const setMultiFilter = ({provider, gameType}) => {
        if (provider && gameType) {
            return [['BrandName', '=', provider], ['GameTypeKey', '=', gameType]];
        }
        if (provider) {
            return ['BrandName', '=', provider];
        }
        if (gameType) {
            return ['GameTypeKey', '=', gameType];
        }
    };

    useEffect(() => {
        if (isSlotBattles) {
            setFiltering({
                sort: [
                    { selector: 'SortOrder', desc: false },
                    { selector: 'GameName', desc: false },
                ],
            })
        }
    }, [isSlotBattles]);

    /****************** ***********************/
    useEffect(() => {
        setSubMenuVisible(true);
        if (presetFilters.currentView.includes('provider') || presetFilters.currentView.includes('gameType')) {
            let sortArr = [
                ...(gamesType === 'slots'
                    ? [{ selector: 'JackpotOrder', desc: false }]
                    : []),
                { selector: 'SortOrder', desc: false },
                { selector: 'GameName', desc: false },
            ];
            sortArr = [{selector: 'IsPromoted', desc: true}, ...sortArr];
            setFiltering({
                select: initFiltering.select[gamesType],
                filter: setMultiFilter({
                    provider: presetFilters.activeProvider,
                    gameType: presetFilters.activeType
                }),
                sort: sortArr
            });
        }
        if (presetFilters.currentView.includes('search')) {
            setFiltering({
                select: initFiltering.select[gamesType],
                filter: ['GameName', 'contains', presetFilters.search],
                sort: [
                    ...(gamesType === 'slots'
                        ? [{ selector: 'JackpotOrder', desc: false }]
                        : []),
                    { selector: 'SortOrder', desc: false },
                    { selector: 'GameName', desc: false },
                ],
            });
            return true;
        }
        if (presetFilters.currentView.includes('new')) {
            setFiltering({
                select: initFiltering.select[gamesType],
                filter: ['GameName', '<>', ''],
                sort: [
                    { selector: 'IsGameNew', desc: true },
                    { selector: 'Created', desc: true },
                    ...(gamesType === 'slots'
                        ? [{ selector: 'JackpotOrder', desc: false }]
                        : []),
                    { selector: 'SortOrder', desc: false },
                    { selector: 'GameName', desc: false },
                ],
            });
            return true;
        }
        if (presetFilters.currentView.includes('popular')) {
            setFiltering({
                select: initFiltering.select[gamesType],
                filter: ['GameName', '<>', ''],
                sort: [
                    { selector: 'LaunchCnt', desc: true },
                    ...(gamesType === 'slots'
                        ? [{ selector: 'JackpotOrder', desc: false }]
                        : []),
                    { selector: 'SortOrder', desc: false },
                    { selector: 'GameName', desc: false },
                ],
            });
        }
        if (presetFilters.currentView.includes('featured')) {
            setFiltering({
                select: initFiltering.select[gamesType],
                filter: ['IsFeatured', '=', '1'],
                sort: [
                    { selector: 'SortOrder', desc: false },
                    { selector: 'GameName', desc: false },
                ],
            });
        }
        if (presetFilters.currentView.includes('favorite')) {
            setFiltering({
                select: initFiltering.select[gamesType],
                filter: [['GameName', '<>', ''], ['FavoriteOrder', '>', '0']],
                sort: [
                    {selector: 'FavoriteOrder', desc: true},
                ],
            });
        }
        if (presetFilters.currentView.includes('recently-played')) {
            setFiltering({
                select: initFiltering.select[gamesType],
                filter: [['GameName', '<>', ''], ['LastLaunchTime', '<>', null]],
                sort: [
                    {selector: 'LastLaunchTime', desc: true},
                ],
            });
        }
        if (presetFilters.currentView.includes('jackpots')) {
            setFiltering({
                select: initFiltering.select[gamesType],
                filter: ['GameName', '<>', ''],
                sort: [
                    {selector: 'Created', desc: true},
                    {selector: 'SortOrder', desc: false},
                    {selector: 'GameName', desc: false},
                ],
            });
            return true;
        }
    }, [JSON.stringify(slotsCasinoGames.gamesViewType), JSON.stringify(slotsCasinoGames.gamesFilterByType)]);

    /********* DATA LOADING ON RENDER ON LOGIN/SIGN OUT ************/
    useEffect(() => {
        setFiltersLoading(true);

        slotsCasinoGames
            .getFilters({gamesType})
            .then(() => setFiltersLoading(false));
    }, [user.isLogged]);
    /****************** ***********************/

    const isProviderWithJackpot = presetFilters.currentView.includes('provider') &&
        store.slotsCasinoGames.providerJackpots({ name: presetFilters.activeProvider })?.length;

    /******************** RENDER *********************/
    return (
        <GamesContext.Provider
            value={{
                mode,
                setMode,
                searchGames,
                gamesType,
                filtering,
                resetFiltering,
                setSorting,
                activeGameMenuItem,
                setActiveGameMenuItem,
                activeSubSubMenuItem,
                setActiveSubSubMenuItem,
                router,
                isSlotBattles,
            }}
        >
            <div className={`ll-page ${gamesType} ${gamesType}--${viewSize}`}>
                {filtersLoading ? (
                    <div className="slots-casino--loader-container">
                        <LLPreloader />
                    </div>
                ) : !pageError ? (
                    <>
                        <div className={`games__header`}>
                            {widgetsLoading ? (
                                <div className="games__header-banner games__header-banner-loading-wrp">
                                    <LLPreloader />
                                </div>
                            ) : banners.length ? (
                                <HomeCarousel
                                    homeSlides={banners}
                                    speed={1000}
                                    delay={3000}
                                    sliderRef={bannersSliderRef}
                                    autoplay={true}
                                    sliderHeight={
                                        {
                                            desktop: '300px',
                                            tablet: '120px',
                                            mobile: '140px',
                                        }[viewSize]
                                    }
                                    className={
                                        'games__header-banner games__header-banner-slider home-page__banner-slider'
                                    }
                                />
                            ) : (
                                <div className="games__header-banner games__header-banner--default" />
                            )}
                            <SlotsCasinosGamesMenu
                                gamesType={gamesType}
                                currentSorting={filtering.sort}
                                setSorting={setSorting}
                                resetFiltering={resetFiltering}
                                gamesMenu={gamesMenu}
                                setPageError={setPageError}
                                activeGameMenuItem={activeGameMenuItem}
                                setActiveGameMenuItem={setActiveGameMenuItem}
                                activeSubSubMenuItem={activeSubSubMenuItem}
                                setActiveSubSubMenuItem={setActiveSubSubMenuItem}
                                isSubMenuVisible={isSubMenuVisible}
                                setSubMenuVisible={setSubMenuVisible}
                            />
                        </div>
                        {isSlotBattles ? (
                            <SlotsBattles />
                        ) : (
                            <>
                                <SlotsCasinosGamesList
                                    filtering={filtering}
                                    gamesType={gamesType}
                                    currentView={presetFilters.currentView}
                                    setPageError={setPageError}
                                    activeProvider={presetFilters.activeProvider}
                                    activeJackpot={presetFilters.activeJackpot}
                                    activeGameMenuItem={activeGameMenuItem}
                                    setActiveGameMenuItem={setActiveGameMenuItem}
                                    activeSubSubMenuItem={activeSubSubMenuItem}
                                    setActiveSubSubMenuItem={setActiveSubSubMenuItem}
                                    isProviderWithJackpot={isProviderWithJackpot}
                                />
                                {isProviderWithJackpot &&
                                !presetFilters.activeJackpot ? (
                                    <>
                                        <div className="game-list-divider">
                                            {viewSize === 'mobile'
                                                ? presetFilters.activeProvider
                                                : ''}
                                        </div>
                                        <SlotsCasinosGamesList
                                            filtering={{
                                                ...filtering,
                                                filter: [
                                                    [
                                                        'BrandName',
                                                        '=',
                                                        presetFilters.activeProvider,
                                                    ],
                                                    ['jackpotId', '=', null],
                                                ],
                                            }}
                                            gamesType={gamesType}
                                            currentView={presetFilters.currentView}
                                            setPageError={setPageError}
                                            activeProvider={presetFilters.activeProvider}
                                            activeGameMenuItem={activeGameMenuItem}
                                            setActiveGameMenuItem={setActiveGameMenuItem}
                                            activeSubSubMenuItem={activeSubSubMenuItem}
                                            setActiveSubSubMenuItem={
                                                setActiveSubSubMenuItem
                                            }
                                            noJackpotCards={true}
                                        />
                                    </>
                                ) : null}
                            </>
                        )}
                    </>
                ) : (
                    <p>{trans('Sorry, this page are not available now')}</p>
                )}
            </div>
        </GamesContext.Provider>
    );
};

export default inject('store')(observer(SlotsCasinos));
